import "./styles.css";

function Pendente() {
  return (
    <div className="pendenteNotify">
      <span className="notificationsTitle">Chegou a hora!</span>
      <span className="notificationsSubTitle">
        Envie sua <span className="nf">Nota Fiscal</span>
      </span>
    </div>
  );
}

export default Pendente;
